import { atom } from 'recoil';

export const setFetchSymptoms = atom({
    key: 'setFetchSymptoms', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  